import {actions, ActionType} from './action';
import {IMaintenancePopup} from '../../common/type';
import {
  createReducer,
  ReducerActionHelper,
  createBasicReducerHandlers,
} from '../../common/util/redux';

export interface IStateCommonSub {
  isLikeAnimating: boolean;
  maintenancePopup?: IMaintenancePopup;
  showHomePopup?: boolean;
}

const INITIAL_STATE: IStateCommonSub = {
  isLikeAnimating: false,
  maintenancePopup: undefined,
};

export default createReducer<
  IStateCommonSub,
  ReducerActionHelper<typeof actions>
>(INITIAL_STATE, {
  ...createBasicReducerHandlers({
    setValueActionType: ActionType.SetValue,
  }),
});
